import { CustomListFieldDefinitionTypeEnum } from '../../../enum/custom-lists/custom-list-field-definition-type.enum';

export const customListFieldType = (fieldType: CustomListFieldDefinitionTypeEnum) => (component: any) => {
  component.customListFieldType = fieldType;
  return component;
};
